/**
 * Model to a configured season body assessment measurement setting
 */
import { IdentityBodyAssessMeasurement } from '@reg/shared/model';

export class IdentitySeasonBodyAssessSetting {
    public id: string = null;
    public seasonId: number = null;
    public readingCount: number = null;
    public minValue: number = null;
    public maxValue: number = null;
    public measurement: IdentityBodyAssessMeasurement = null;

    public clone(): IdentitySeasonBodyAssessSetting {
        const clone: IdentitySeasonBodyAssessSetting = new IdentitySeasonBodyAssessSetting();
        clone.id = this.id;
        clone.seasonId = this.seasonId;
        clone.readingCount = this.readingCount;
        clone.minValue = this.minValue;
        clone.maxValue = this.maxValue;

        if (this.measurement) {
            clone.measurement = this.measurement.clone();
        }

        return clone;
    }

    /**
     * Deserialize to json api format
     */
    public deserialize(json: Object, included: Object[] = null): IdentitySeasonBodyAssessSetting {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'] || [];
        const relationships: Object = data['relationships'] || [];

        this.id = data['id'];
        this.seasonId = attrs['seasonId'];
        this.readingCount = parseInt(attrs['readingCount'], null);
        this.minValue = attrs['minValue'] && parseFloat(attrs['minValue']);
        this.maxValue = attrs['maxValue'] && parseFloat(attrs['maxValue']);

        const measurementLink: Object = relationships['bodyAssessmentMeasurement'];
        if (measurementLink &&
            included &&
            measurementLink['data'] &&
            measurementLink['data']['id']) {
            const measurementId: string = measurementLink['data']['id'];
            const measurements: Object[] =
                included.filter((i: Object) => i['type'] === 'bodyAssessmentMeasurement' && i['id'] === measurementId);

            if (measurements.length === 1) {
                this.measurement = (new IdentityBodyAssessMeasurement()).deserialize(measurements[0], included);
            }
        } else if (attrs['bodyAssessmentMeasurementId']) {
            this.measurement = new IdentityBodyAssessMeasurement();
            this.measurement.id = attrs['bodyAssessmentMeasurementId'];
        }

        return this;
    }
}
